import { render } from "./CategorizationStep.vue?vue&type=template&id=2b4fe8fb&scoped=true&ts=true"
import script from "./CategorizationStep.vue?vue&type=script&lang=ts"
export * from "./CategorizationStep.vue?vue&type=script&lang=ts"

import "./CategorizationStep.vue?vue&type=style&index=0&id=2b4fe8fb&scoped=true&lang=scss"

import exportComponent from "/tmpfs/builds/maltcommunity/malt/apps/malt/node_modules/.pnpm/vue-loader@17.0.1_p6ywf2fz4v3oextcdrklqlunue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b4fe8fb"]])

export default __exports__